import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Kumpa";

const KumpaSprings = () => {
  const projectId = 19;
  const title = "Kumpa Springs";

  const mapConfig = {
    zoom: 15,
    searchPrefix: "og",
    // No explicit minZoom or bounds in original component
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links were commented out/incorrect in legacy component
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default KumpaSprings;
